import { EditOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Col, Form, Input, Row, Card, InputNumber, message } from 'antd';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import 'react-phone-input-2/lib/style.css';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { fetchDiePressById, editDiePress } from '../../slices/die-press';

export default function EditPress() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { id } = useParams();

  const { loading } = useSelector(state => state.diePress);

  useEffect(() => {
    const fetchDiePress = async () => {
      try {
        const response = await dispatch(fetchDiePressById(id)).unwrap();

        if (response?.success) {
          const data = response?.data;
          form.setFieldsValue({
            name: data?.name,
            code: data?.code,
            capacity: data?.capacity,
            billet_diameter: data?.billet_diameter || 0,
            billet_length_min: data?.billet_length_min || 0,
            billet_length_max: data?.billet_length_max || 0,
            billet_weight: data?.billet_weight || 0,
            extrusion_length_min: data?.extrusion_length_min || 0,
            extrusion_length_max: data?.extrusion_length_max || 0,
          });


        } else {
          console.warn('No data found for the given ID.');
        }
      } catch (error) {
        console.error('');
      }
    };

    fetchDiePress();
  }, [id]);

  const handleFinish = values => {

    dispatch(editDiePress({ id, values }))
      .unwrap()
      .then(result => {
        if (result.success) {
          message.success('Press Updated Successfully!');
          navigate('/die-press');
        }
      })
      .catch(error => {
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }

          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error); // Handle string error
        } else if (error instanceof Error) {
          message.error(error.message); // Handle Error object
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };

  const handleError = error => {
    if (typeof error === 'object' && error !== null) {
      const messages = [];
      for (const key in error) {
        if (Array.isArray(error[key])) {
          messages.push(`${key}: ${error[key].join(', ')}`);
        }
      }
      message.error(
        messages.length > 0
          ? messages.join('; ')
          : 'An unknown error occurred.',
      );
    } else if (typeof error === 'string') {
      message.error(error);
    } else if (error instanceof Error) {
      message.error(error.message);
    } else {
      message.error('An unknown error occurred.');
    }
  };


  return (
    <>
      <div className="sticyaction">
        <div className="pagenamerow">
          <h2>Edit Press</h2>
          <div className="bredcrumbwrp">
            <Link to="/die-press" className="back">
              <Back /> BACK
            </Link>
            <Breadcrumb
              items={[
                { title: <Link to="/die-press">Press</Link> },
                { title: 'Edit Press' },
              ]}
            />
          </div>
        </div>
      </div>
      <div className="formwrapper">
        <Form
          layout="vertical"
          form={form}
          onFinish={handleFinish}
          autoComplete="off"
        >
          <Row gutter={24}>
            <Col xs={12} sm={12} md={4} lg={4}>
              <Form.Item
                name="name"
                label="Press Name"
                rules={[
                  { required: true, message: 'Please enter press name!' },
                  {
                    max: 49,
                    message: 'press name cannot be longer than 50 characters '
                  }
                ]}
              >
                <Input
                  maxLength={50}
                  placeholder="Enter Press Name"
                />
              </Form.Item>
            </Col>
            <Col xs={12} sm={12} md={4} lg={4}>
              <Form.Item
                name="code"
                label="Press Code"
                rules={[{ required: true, message: "Please input press code" }]}
              >
                <Input placeholder="e.g. P-1200T" />
              </Form.Item>
            </Col>
            <Col xs={12} sm={12} md={4} lg={4}>
              <Form.Item
                name="capacity"
                label="Press Capicity (Tonnage)"
                rules={[{ required: true, message: "Please input press capicity" }]}
              >
                <Input placeholder="e.g. 000" />
              </Form.Item>
            </Col>
            <Col xs={12} sm={12} md={4} lg={4}>
              <Form.Item
                name="billet_weight"
                label="Billet Weight (mm)"
                rules={[{ required: true, message: "Please input billet weight" }]}
              >
                <InputNumber  style={{ width: "100%" }} placeholder="e.g. 000" />
              </Form.Item>
            </Col>
             <Col xs={12} sm={12} md={4} lg={4}>
              <Form.Item
                name="billet_diameter"
                label="Billet Diameter (mm)"
                rules={[{ required: true, message: "Please input billet diameter" }]}
              >
                <InputNumber style={{ width: "100%" }} placeholder="e.g. 000" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            {/* <Col xs={24} md={12}>
              <Card size="small" title="Billet Diameter (mm)" variant="borderless" style={{ marginBottom: 12, boxShadow: "none", background: "transparent" }}>
                <Row gutter={12}>
                  <Col xs={24} sm={12}>
                    <Form.Item
                      name="billet_diameter_min"
                      label="Min"
                      //rules={[{ required: true, message: "Please input min diameter" }]}
                      rules={[
                        { required: true, message: "Please input min diameter" },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            const max = getFieldValue("billet_diameter_max");
                            if (value && max && value >= max) {
                              return Promise.reject("Min length must be less than max length");
                            }
                            return Promise.resolve();
                          },
                        }),
                      ]}
                    >
                      <InputNumber style={{ width: "100%" }} min={0} placeholder="0" />
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={12}>
                    <Form.Item
                      name="billet_diameter_max"
                      label="Max"
                      //rules={[{ required: true, message: "Please input max diameter" }]}
                      rules={[
                        { required: true, message: "Please input max diameter" },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            const min = getFieldValue("billet_diameter_min");
                            if (value && min && value <= min) {
                              return Promise.reject("Max length must be greater than min length");
                            }
                            return Promise.resolve();
                          },
                        }),
                      ]}
                    >
                      <InputNumber style={{ width: "100%" }} min={0} placeholder="0" />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
            </Col> */}
            <Col xs={24} md={12}>
              <Card size="small" title="Billet Length (mm)" variant="borderless" style={{ marginBottom: 12, boxShadow: "none", background: "transparent" }}>
                <Row gutter={12}>
                  <Col xs={24} sm={12}>
                    <Form.Item
                      name="billet_length_min"
                      label="Min"
                      //rules={[{ required: true, message: "Please input min billet length" }]}
                      rules={[
                        { required: true, message: "Please input min billet length" },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            const max = getFieldValue("billet_length_max");
                            if (value && max && value >= max) {
                              return Promise.reject("Min length must be less than max length");
                            }
                            return Promise.resolve();
                          },
                        }),
                      ]}
                    >
                      <InputNumber style={{ width: "100%" }} placeholder="0" />
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={12}>
                    <Form.Item
                      name="billet_length_max"
                      label="Max"
                      // rules={[{ required: true, message: "Please input max billet length" }]}
                      rules={[
                        { required: true, message: "Please input max billet length" },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            const min = getFieldValue("billet_length_min");
                            if (value && min && value <= min) {
                              return Promise.reject("Max length must be greater than min length");
                            }
                            return Promise.resolve();
                          },
                        }),
                      ]}
                    >
                      <InputNumber style={{ width: "100%" }}  placeholder="0" />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
            </Col>
            <Col xs={24} md={12}>
              <Card size="small" title="Extrusion Length (m)" variant="borderless" style={{ marginBottom: 12, boxShadow: "none", background: "transparent" }}>
                <Row gutter={12}>
                  <Col xs={24} sm={12}>
                    <Form.Item
                      name="extrusion_length_min"
                      label="Min"
                      rules={[
                        { required: true, message: "Please input min extrusion length" },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            const max = getFieldValue("extrusion_length_max");
                            if (value && max && value >= max) {
                              return Promise.reject("Min length must be less than max length");
                            }
                            return Promise.resolve();
                          },
                        }),
                      ]}
                    >
                      <InputNumber style={{ width: "100%" }}  placeholder="0" />
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={12}>
                    <Form.Item
                      name="extrusion_length_max"
                      label="Max"
                      rules={[
                        { required: true, message: "Please input max extrusion length" },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            const min = getFieldValue("extrusion_length_min");
                            if (value && min && value <= min) {
                              return Promise.reject("Max length must be greater than min length");
                            }
                            return Promise.resolve();
                          },
                        }),
                      ]}
                    >
                      <InputNumber style={{ width: "100%" }}  placeholder="0" />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>

          <div className="flex justify-end">
            <Button type="primary" htmlType="submit" size="large" loading={loading} icon={<EditOutlined />}>
              Update Press
            </Button>
          </div>
        </Form>
      </div>
    </>
  );
}
